export default `<script>
  function copy_data1(containerid) {
    var orig = document.getElementById('st1').innerHTML;
    var a = orig;
    a = a.replace(/’/g, '');
    a = a.replace(/,/g, '');
    document.getElementById('st1').innerHTML = a;
    var range = document.createRange();
    range.selectNode(containerid);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
    document.execCommand('copy');
    window.getSelection().removeAllRanges();
    document.getElementById('st1').innerHTML = orig;
  }
  function copy_data2(containerid) {
    var orig = document.getElementById('st2').innerHTML;
    var a = orig;
    a = a.replace(/’/g, '');
    a = a.replace(/,/g, '');
    document.getElementById('st2').innerHTML = a;
    var range = document.createRange();
    range.selectNode(containerid);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
    document.execCommand('copy');
    window.getSelection().removeAllRanges();
    document.getElementById('st2').innerHTML = orig;
  }
  function copy_data3(containerid) {
    var orig = document.getElementById('st3').innerHTML;
    var range = document.createRange();
    range.selectNode(containerid);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
    document.execCommand('copy');
    window.getSelection().removeAllRanges();
    document.getElementById('st3').innerHTML = orig;
  }
</script>
<table style="width: auto; min-width: fit-content;">
  <tr>
    <td translate>Swiss grid (LV95)</td>
    <td>
      <div id="st1">{{coord_2056|ngeoNumberCoordinates:1:'{x}, {y}'}}</div>
    </td>
    <td>
      <button
        style="cursor: pointer"
        title="{{'Koordinaten in die Zwischenablage kopieren.'|translate}}"
        onclick="copy_data1(st1)"
        class="btn"
      >
        <i class="far fa-copy"></i>
      </button>
    </td>
  </tr>
  <tr>
    <td translate>Swiss grid (LV03)</td>
    <td>
      <div id="st2">{{coord_21781|ngeoNumberCoordinates:1:'{x}, {y}'}}</div>
    </td>
    <td>
      <button
        style="cursor: pointer"
        title="{{'Koordinaten in die Zwischenablage kopieren.'|translate}}"
        onclick="copy_data2(st2)"
        class="btn"
      >
        <i class="far fa-copy"></i>
      </button>
    </td>
  </tr>
  <tr>
    <td translate>Wgs Coord.</td>
    <td>
      <div id="st3">{{coord_4326|ngeoNumberCoordinates:3:'{y}, {x}'}}</div>
    </td>
    <td>
      <button
        style="cursor: pointer"
        title="{{'Koordinaten in die Zwischenablage kopieren.'|translate}}"
        onclick="copy_data3(st3)"
        class="btn"
      >
        <i class="far fa-copy"></i>
      </button>
    </td>
  </tr>
   <tr>
    <td translate>Wgs Coord. DMS</td>
    <td>{{coord_4326|ngeoDMSCoordinates:0:'{y} {x}'}}</td>
  </tr>
  <tr>
    <td translate>Elevation (DTM2)</td>
    <td ng-if="DTM2">{{DTM2 | number}} m</td>
  </tr>
</table>
<a
  ng-href="https://maps.google.ch/?ie=UTF8&ll={{coord_4326_northern}},{{coord_4326_eastern}}&layer=c&cbll={{coord_4326_northern}},{{coord_4326_eastern}}&cbp=12,57.78,,0,8.1"
  target="_blank"
  >Google StreetView</a
>`;
